import { IconCritical, Text } from 'braid-design-system';

interface ResultLabelProps {
  terminateIntegration: boolean;
}

export const ResultLabel = ({ terminateIntegration }: ResultLabelProps) =>
  terminateIntegration ? (
    <Text tone="critical" weight="strong" icon={<IconCritical />}>
      Your integration will be shut off by invalidating your credentials with
      SEEK. All users associated with your account will be locked out of the
      dashboard. SEEK will contact you to discuss further.
    </Text>
  ) : (
    <Text tone="info">SEEK will contact you to discuss further.</Text>
  );
